<template>
  <div v-if="configReady">
    <v-dialog v-model="uploading" fullscreen full-width>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
    <aru-autoform
      dismiss-button
      @dismiss="dismiss"
      @submit="submit"
      v-model="adminDoc"
      :form-configuration="config.adminForm"
    ></aru-autoform>
  </div>
</template>

<script>
import AruAutoform from '@/components/commons/form/AruAutoForm.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  components: {
    AruAutoform,
  },
  data() {
    return {
      config: {},
      configReady: false,
      adminDoc: {},
      uploading: false,
    };
  },
  mounted() {
    this.configReady = false;
    apiCtrl.get('/config/document').then(res => {
      this.config = res.data.data;
      console.log({ CONFIGURATION: this.config });
      this.configReady = true;
    });
  },
  methods: {
    dismiss() {
      this.$emit('closeDialog');
    },
    submit() {
      this.uploading = true;
      let formData = new FormData();

      /*
                    Add the form data we need to submit
                */
      for (const field in this.adminDoc) {
        if (this.adminDoc.hasOwnProperty(field)) {
          const value = this.adminDoc[field];
          formData.append(field, value);
        }
      }

      apiCtrl
        .postUpload('/document', formData)
        .then(res => {
          this.uploading = false;
          console.log(res);
          this.$emit('submit');
        })
        .error(error => {
          this.uploading = false;
        });
    },
  },
};
</script>

<style></style>
